import React from 'react'
import Curator from './Curator'

const CuratorProfile = () => {
  return <Curator />
}

export default CuratorProfile
